import Cookies from 'js-cookie'
import mutatinTypes from '@/store/utils/mutation-types'
var resizeTimeoutId = null;
const app = {
  state: {
    screenSizeHanders: [],
    sceneInitProgress: 0,
    login: {},
    config: {},//用户记忆配置
  },
  mutations: {
    // this.$store.commit(this.$store.state.mutatinTypes.SUB_SCREEN_RESIZE, {
    //   partId: "loginVue",
    //   action: this.screenSizeChange
    // });
    [mutatinTypes.SUB_SCREEN_RESIZE](state, param) {
      if (state.screenSizeHanders.find(el => el.partId == param.partId)) return;
      state.screenSizeHanders.push(param);
    },
    [mutatinTypes.INIT_SCREEN_RESIZE](state) {
      state.screenSizeHanders.forEach(item => {
        try {
          if (typeof item.action == "undefined")
            return;
          item.action();
        }
        catch (err) {
          console.log(err);
        }
      });
    },
    [mutatinTypes.SCENE_INIT_PROGRESS](state, val) {
      state.sceneInitProgress = val;
    },
    [mutatinTypes.SETLOGIN](state, val) {
      state.login = val;
    },
    [mutatinTypes.SETCONFIG](state, val) {
      state.config = val;
    }
  },
  actions: {
    [mutatinTypes.INIT_SCREEN_RESIZE]({ commit }) {
      var that = commit;
      window.onresize = () => {
        if (resizeTimeoutId != null) return;
        resizeTimeoutId = setTimeout(() => {
          that(mutatinTypes.INIT_SCREEN_RESIZE)
          resizeTimeoutId = null;
        }, 500);
      }
    }
  }
}

export default app
